import { http, HttpResponse } from 'msw';

import { getOptionPositions, getPositionsHistory } from '@core/option';

import { Storage } from '../storage';
import { parseUrl } from '../utils';
import positionsData from '../data/position/positions.json';
import positionsHistoryData from '../data/position/positions-history.json';

type TGetOptionPositions = HttpGet<typeof getOptionPositions>;
type TGetPositionsHistory = HttpGet<typeof getPositionsHistory>;

export const positionsStorage = new Storage('positions', positionsData);

export default [
  http.get<
    TGetOptionPositions[0],
    TGetOptionPositions[1],
    TGetOptionPositions[2]
  >(parseUrl(getOptionPositions.url), () => {
    const data = positionsStorage.getValue();
    return HttpResponse.json(data as unknown as TGetOptionPositions[2]);
  }),
  http.get<
    TGetPositionsHistory[0],
    TGetPositionsHistory[1],
    TGetPositionsHistory[2]
  >(parseUrl(getPositionsHistory.url), () => {
    return HttpResponse.json(
      positionsHistoryData as unknown as TGetPositionsHistory[2]
    );
  }),
];
